import { passkeyService } from '@egw/auth'
import { type FC } from 'react'
import { VerifyPhoneLinkV2 } from '../../../components/verify-phone-link-v2/verify-phone-link-v2'
import { VerifyPhoneOtpV2 } from '../../../components/verify-phone-otp-v2/verify-phone-otp-v2'

export const VerifyPhonePage: FC = () => {
  const isMobile = passkeyService.getIsMobile()

  if (!isMobile) {
    return <VerifyPhoneOtpV2 />
  }

  return <VerifyPhoneLinkV2 />
}
